import styles from "./label.module.css";

/**
 * Component that displays a required asterisk
 */
export const Required = () => {
    return <span className={styles.required}>*</span>;
};
